var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{on:{"click":_vm.cancel}},[_vm._v("Cancel Subscription")])
}
var staticRenderFns = []

export { render, staticRenderFns }